export default __webpack_public_path__ + "static/media/blueTick.66dcde83.svg";